import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { Divider } from '@material-ui/core'
import {styles} from '../../CSS/Styles'
import TextField from '@material-ui/core/TextField'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import SimpleSelect from '../../CSSComponent/dropdownselection'
import DatePicker from "react-datepicker"
import Button from '@material-ui/core/Button'
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import "../../CSS/customDatePickerWidth.css";

const theme = createMuiTheme({
  overrides: {
    MuiInput: {
      underline: {
        "&&&&:before": {
            borderBottom: "0px solid rgba(0, 0, 0, 0)"
        },
        "&&&&:hover:before": {
          borderBottom: "0px solid rgba(0, 0, 0, 0)"
        }
      }
    }
  }
});
class ActionPlan extends React.Component {

    constructor(props) {
        super(props)

        let ActionPlanNo = []
        let ActionPlanDescription = []
        let ActionOwner = []
        let ActionType = []
        let ControlRef = []
        let implementationStatus = []
        let actionTimeline = []
        for (let itemindex in this.props.action) {
            let item = this.props.action[itemindex]
            ActionPlanNo.push(item.action_plans_no)
            ActionPlanDescription.push(item.summary_of_action_plans)
            ActionOwner.push(item.action_plans_owner)
            ActionType.push(item.action_type)
            ControlRef.push(item.control_reference)
            implementationStatus.push(item.implementation_status)
            actionTimeline.push(item.timeline)
        }

        this.state = {
            action:this.props.action,
            ActionPlanNo: ActionPlanNo,
            ActionPlanDescription: ActionPlanDescription,
            ActionOwner: ActionOwner,
            ActionType: ActionType,
            ControlRef: ControlRef,
            implementationStatus: implementationStatus,
            actionDueTimeline: actionTimeline
        }
    }

    componentDidUpdate(prevProps) {
        // console.log("new id : " + this.props.queryID + "vs old id : " + prevProps.queryID);
        if (this.props != prevProps) {
            let ActionPlanNo = []
            let ActionPlanDescription = []
            let ActionOwner = []
            let ActionType = []
            let ControlRef = []
            let implementationStatus = []
            let actionTimeline = []
            for (let itemindex in this.props.action) {
                let item = this.props.action[itemindex]
                ActionPlanNo.push(item.action_plans_no)
                ActionPlanDescription.push(item.summary_of_action_plans)
                ActionOwner.push(item.action_plans_owner)
                ActionType.push(item.action_type)
                ControlRef.push(item.control_reference)
                implementationStatus.push(item.implementation_status)
                actionTimeline.push(item.timeline)
            }
            this.setState({
                action:this.props.action,
                ActionPlanNo: ActionPlanNo,
                ActionPlanDescription: ActionPlanDescription,
                ActionOwner: ActionOwner,
                ActionType: ActionType,
                ControlRef: ControlRef,
                implementationStatus: implementationStatus,
                actionDueTimeline: actionTimeline
            })
        }
    }

    handleDueDateChange = (date, index) => {
        //console.log('handleDueDateChange : ' + date)
        this.setState(()=>{this.state.actionDueTimeline[index] = date},()=>{
            this.props.submitChange('actionTimeline', this.state.actionDueTimeline)
        })
        this.forceUpdate()
    }

    handleChange = (name, index) => event => {
        let newdata = this.state[name]
        newdata[index] = (event.target.checked ? '✔' : null)
        this.setState({ [name]: newdata },()=>{
            this.props.submitChange(name, this.state[name])
        })

    };

    handleListSelect = (key, value, index) => {
        this.setState((state)=>{ this.state[key][index] = value }, ()=>{
            this.props.submitChange(key, this.state[key])
        })
    };


    handleTextChange = (name, index, event) => {

        let value = event.target.value
        this.setState((state)=>{ 
            this.state[name][index] = value 
            this.props.submitChange(name, this.state[name])
        })
        this.forceUpdate()
    };

    handleAddNew = (event) => {
        // get the type (as data-value in the dom element), here need to use its parent, because the event target return only the button not its wrapper
        let updateList = this.state.action
        updateList.push("")
        this.setState({action: updateList}, ()=>{
            this.props.submitChange('action', updateList)
        })
    }

    handleDrop = (event) => {

        let index = event.target.parentNode.dataset.index
        // if click on the border of the button, it returns the parents........
        if (index == null) {
            index = event.target.dataset.index
        }
        let updateListaction = this.state.action
        let updateListActionPlanNo = this.state.ActionPlanNo
        let updateListActionPlanDescription = this.state.ActionPlanDescription
        let updateListActionOwner = this.state.ActionOwner
        let updateListActionType = this.state.ActionType
        let updateListControlRef = this.state.ControlRef
        let updateListimplementationStatus = this.state.implementationStatus
        let updateListactionDueTimeline = this.state.actionDueTimeline

        updateListaction.splice(index, 1)
        updateListActionPlanNo.splice(index, 1)
        updateListActionPlanDescription.splice(index, 1)
        updateListActionOwner.splice(index, 1)
        updateListActionType.splice(index, 1)
        updateListControlRef.splice(index, 1)
        updateListimplementationStatus.splice(index, 1)
        updateListactionDueTimeline.splice(index, 1)

        this.setState({
            action: updateListaction,
            ActionPlanNo: updateListActionPlanNo,
            ActionPlanDescription: updateListActionPlanDescription,
            ActionOwner: updateListActionOwner,
            ActionType: updateListActionType,
            ControlRef: updateListControlRef,
            implementationStatus: updateListimplementationStatus,
            actionDueTimeline: updateListactionDueTimeline
        }, ()=>{
            this.props.submitChange('action', updateListaction)
            this.props.submitChange('ActionPlanNo', updateListActionPlanNo)
            this.props.submitChange('ActionPlanDescription', updateListActionPlanDescription)
            this.props.submitChange('ActionOwner', updateListActionOwner)
            this.props.submitChange('ActionType', updateListActionType)
            this.props.submitChange('ControlRef', updateListControlRef)
            this.props.submitChange('implementationStatus', updateListimplementationStatus)
            this.props.submitChange('actionDueTimeline', updateListactionDueTimeline)
        })
    }

    render() {
        const { classes } = this.props;
        let namelist = []
        for (let list in this.props.employee) {
            namelist.push(this.props.employee[list].name + ', ' + this.props.employee[list].designation)
        }
        let actionTypeOption = ['Enhance Control', 'New Control']
        let implementationStatusOption = ['On Track', 'Delayed', 'Completed']
        const ActionPlanTable = (
            <div>
                <Table padding='dense'>
                    <TableHead>
                        <TableRow style={{height:'40px'}}>
    
                            <TableCell align = 'center' rowSpan={2} > No </TableCell>
                            <TableCell align = 'center' rowSpan={2} > Description </TableCell>
                            <TableCell align = 'center' rowSpan={2} > Action Plan Owner </TableCell>
                            <TableCell align = 'center' colSpan={2} > Type of Action Plans </TableCell>
                            <TableCell align = 'center' rowSpan={2} > Control Strength</TableCell>
                            <TableCell align = 'center' rowSpan={2} > Timeline </TableCell>
                        </TableRow>
                        <TableRow style={{height:'40px'}}>
                            <TableCell align = 'center' rowSpan={2} style={{ whiteSpace: 'nowrap',  padding: '10px 2px 10px 2px' }}> Type </TableCell>
                            <TableCell align = 'center' rowSpan={2} style={{ whiteSpace: 'nowrap',  padding: '10px 2px 10px 2px' }}> Ref. </TableCell>
                        </TableRow>
                    </TableHead>
    
                    <TableBody>
                        {this.state.action.map((controlitem, index)=>{
                            if(this.state.actionDueTimeline == null) {
                                return null
                            }
                            //console.log(this.state.actionDueTimeline)
                            return(
                                <TableRow style={{height:'40px'}}>
                                    <TableCell align = 'center' style={{ padding: '10px 2px 10px 2px' }}> 
                                        <TextField
                                            id = "ActionPlanNo"
                                            InputProps={{ style: { fontSize: 15 }}}
                                            inputProps={{ style: { textAlign: "center" }}}
                                            onChange = {(event) => this.handleTextChange("ActionPlanNo", index, event)}
                                            value = {this.state.ActionPlanNo[index]}
                                            placeholder = "A1"
                                        />
                                        <Button
                                            data-index={index}
                                            variant='outlined'
                                            color='secondary'
                                            className={classes.button}
                                            onClick= {this.handleDrop}
                                        >
                                            Drop
                                        </Button>
                                    </TableCell>
                                    <TableCell align = 'center' style={{ padding: '10px 2px 10px 2px' }}> 
                                        <TextField
                                            style= {{width: '16vw'}}
                                            id = "ActionPlanDescription"
                                            InputProps={{ style: { fontSize: 15 }}}
                                            inputProps={{ style: {overflow: "hidden" }}}
                                            multiline = {true}
                                            onChange = {(event) => this.handleTextChange("ActionPlanDescription", index, event)}
                                            value = {this.state.ActionPlanDescription[index]}
                                            placeholder = "Description"
                                        /> </TableCell>
                                    <TableCell align = 'center' style={{ padding: '10px 2px 10px 2px' }}>
                                        <SimpleSelect index={index} id = 'ActionOwner' option = {namelist}  defaultoption={namelist.findIndex(item => item == this.state.ActionOwner[index])} returnSelection={this.handleListSelect}/>
                                    </TableCell>
                                    <TableCell align = 'center' style={{ padding: '10px 2px 10px 2px' }}>
                                        <SimpleSelect index={index} id = 'ActionType' option = {actionTypeOption}  defaultoption={actionTypeOption.findIndex(item => item == this.state.ActionType[index])} returnSelection={this.handleListSelect}/> 
                                    </TableCell>
                                    <TableCell align = 'center' style={{ padding: '10px 2px 10px 2px' }}>
                                        <TextField
                                            id = "ControlRef"
                                            InputProps={{ style: { fontSize: 15 }}}
                                            inputProps={{ style: { textAlign: "center" }}}
                                            onChange = {(event) => this.handleTextChange("ControlRef", index, event)}
                                            value = {this.state.ControlRef[index]}
                                            placeholder = "ControlRef"
                                        /> 
                                    </TableCell>
                                    <TableCell align = 'center' style={{ padding: '10px 2px 10px 2px' }}>
                                        <SimpleSelect index={index} id = 'implementationStatus' option = {implementationStatusOption} defaultoption={implementationStatusOption.findIndex(item => item == this.state.implementationStatus[index])} returnSelection={this.handleListSelect}/> 
                                    </TableCell>
                                    <TableCell align = 'center' style={{ padding: '10px 2px 10px 2px' }}> 
                                        <div className="customDatePickerWidth">
                                            <DatePicker
                                                selected={this.state.actionDueTimeline[index]}
                                                onChange={(data)=>{this.handleDueDateChange(data, index)}}
                                                popperPlacement="top-end"
                                                popperModifiers={{
                                                    offset: {
                                                        enabled: true,
                                                        offset: '5px, 10px'
                                                    },
                                                    preventOverflow: {
                                                        enabled: true,
                                                        escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
                                                        boundariesElement: 'viewport'
                                                    }
                                                }}
                                            /> 
                                        </div>
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>

                </Table>
                <div className={classes.button_table_add_neww}>
                    <Button variant="outlined" color="primary" className={classes.button} onClick= {this.handleAddNew}>
                        Add New
                    </Button>
                </div>
            </div>
        )

        return (
            <MuiThemeProvider theme={theme}>
                <div>
                    <Typography variant = "h6"  align="left" className={classes.FormHeader}> E. Additional Action Plans </Typography>
                    <Divider className={classes.FormDivider}/>
                    {ActionPlanTable}
                </div>
            </MuiThemeProvider>
                    
        )
    }
}

export default withStyles(styles)(ActionPlan);
    


// WEBPACK FOOTER //
// ./src/components/Risks/RiskRegisterSection/E.js